import { render, staticRenderFns } from "./jskh.vue?vue&type=template&id=6245e650&scoped=true&"
import script from "./jskh.vue?vue&type=script&lang=js&"
export * from "./jskh.vue?vue&type=script&lang=js&"
import style0 from "./jskh.vue?vue&type=style&index=0&id=6245e650&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6245e650",
  null
  
)

export default component.exports